export default __webpack_public_path__ + "static/media/slides.2331684e.png";